var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#0F5EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4459 11.9028L20.0941 8.55176C19.9827 8.4403 19.8504 8.35189 19.7048 8.29157C19.5592 8.23124 19.4031 8.2002 19.2455 8.2002C19.0879 8.2002 18.9318 8.23124 18.7862 8.29157C18.6406 8.35189 18.5083 8.4403 18.3969 8.55176L9.14863 17.8C9.03672 17.911 8.94799 18.0432 8.8876 18.1888C8.82721 18.3344 8.79638 18.4906 8.79688 18.6483V22C8.79688 22.3183 8.92331 22.6235 9.14835 22.8485C9.3734 23.0736 9.67862 23.2 9.99688 23.2H22.5969C22.756 23.2 22.9086 23.1368 23.0211 23.0243C23.1337 22.9118 23.1969 22.7591 23.1969 22.6C23.1969 22.4409 23.1337 22.2883 23.0211 22.1758C22.9086 22.0632 22.756 22 22.5969 22H15.0459L23.4459 13.6C23.5573 13.4886 23.6458 13.3563 23.7061 13.2107C23.7664 13.0651 23.7974 12.909 23.7974 12.7514C23.7974 12.5938 23.7664 12.4377 23.7061 12.2921C23.6458 12.1465 23.5573 12.0142 23.4459 11.9028ZM13.3486 22H9.99688V18.6483L16.5969 12.0483L19.9486 15.4L13.3486 22ZM20.7969 14.5518L17.4459 11.2L19.2459 9.40001L22.5969 12.7518L20.7969 14.5518Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.d69c394ad30a03b274e6468d06ada1bf.svg";
export { ForwardRef as ReactComponent };